import { useQuery } from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
import { StringHelper } from "@/utils"

const getCustomers = async (
  params: CustomerSearchParams
): Promise<CustomersResponse> => {
  const newParams = {
    ...params,
    document: StringHelper.onlyAlphanumeric(
      params?.document
    ),
  }
  const queryString =
    StringHelper.objectToQueryString(newParams)
  const url = `${ENDPOINTS.CUSTOMERS}?${queryString}`
  const { data } = await api.get<CustomersResponse>(url)
  return data
}

export const useCustomers = (
  params: CustomerSearchParams,
  enabled = false
) => {
  return useQuery({
    queryKey: [ENDPOINTS.CUSTOMERS, params],
    queryFn: () => getCustomers(params),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    enabled,
  })
}

export default useCustomers
